<div class="modal-header" *ngIf="title">
    <h4 class="modal-title" id="modal-title">{{ title }}</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  
<div class="modal-body">
  <p [innerHTML]="message" style="font-size: 1rem; line-height: 1.6; color: var(--bs-body-color, #212529); margin: 0;"></p>
</div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel')">
      {{ cancelText }}
    </button>
    <button type="button" class="btn" [ngClass]="confirmButtonClass" (click)="modal.close(true)">
      {{ confirmText }}
    </button>
  </div>
